/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ startDate: NonNullable<unknown>, endDate: NonNullable<unknown> }} Campaigns_Mag7_Spacex_Date_LabelInputs */

const en_campaigns_mag7_spacex_date_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Date_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.startDate}-${i?.endDate}`)
};

const de_campaigns_mag7_spacex_date_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Date_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.startDate}–${i?.endDate}`)
};

const pt_br2_campaigns_mag7_spacex_date_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Date_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.startDate}–${i?.endDate}`)
};

const tr_campaigns_mag7_spacex_date_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Date_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.startDate}–${i?.endDate}`)
};

const zh_cn2_campaigns_mag7_spacex_date_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Date_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.startDate}-${i?.endDate}`)
};

const zh_hk2_campaigns_mag7_spacex_date_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Date_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.startDate}-${i?.endDate}`)
};

const ko_kr2_campaigns_mag7_spacex_date_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Date_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.startDate}-${i?.endDate}`)
};

const ru_ru2_campaigns_mag7_spacex_date_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Date_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.startDate}-${i?.endDate}`)
};

const es_419_campaigns_mag7_spacex_date_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Date_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.startDate}-${i?.endDate}`)
};

/**
* | output |
* | --- |
* | "{startDate}-{endDate}" |
*
* @param {Campaigns_Mag7_Spacex_Date_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_date_label = /** @type {((inputs: Campaigns_Mag7_Spacex_Date_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Date_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_date_label(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_date_label(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_date_label(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_date_label(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_date_label(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_date_label(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_date_label(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_date_label(inputs)
	return es_419_campaigns_mag7_spacex_date_label(inputs)
});